import useGame from "../RunicMemoriseContext";
import styles from "../assets/styles.module.scss";

const EndGameModal = () => {
  const { testingInput, reset } = useGame();

  if (testingInput === "pass") {
    return (
      <div className={styles.modalsContainer}>
        <div className={styles.winModal}>
          <h2>You Win</h2>
          <p>¡Congratulations! You have pased the level</p>
          <button
            onClick={() => {
              reset();
            }}>
            Retry
          </button>
        </div>
      </div>
    );
  } else if (testingInput === "lose") {
    return (
      <div className={styles.modalsContainer}>
        <div className={styles.loseModal}>
          <h2>You Lose</h2>
          <p>The sequence was entered in the wrong order</p>
          <button
            onClick={() => {
              reset();
            }}>
            Retry
          </button>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
export default EndGameModal;
